"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactions = void 0;
var react_1 = __importDefault(require("react"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Utils_1 = require("../Utils");
var UseChartMappings_1 = require("./UseChartMappings");
var DonutChart_1 = require("./DonutChart");
var Table_1 = require("./Table");
var UseInteractionCounts_1 = require("./UseInteractionCounts");
var styles = __importStar(require("./TimeSpentAndInteractions.css"));
var Interactions = function (_a) {
    var pageId = _a.pageId, period = _a.period, viewId = _a.viewId;
    var interactionCounts = (0, UseInteractionCounts_1.useInteractionCounts)({
        pageId: pageId,
        viewId: viewId,
        periodStart: period === null || period === void 0 ? void 0 : period.start,
        periodEnd: period === null || period === void 0 ? void 0 : period.end,
    }).interactionCounts;
    if (interactionCounts == undefined) {
        return react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true });
    }
    return react_1.default.createElement(LoadedInteractions, { interactionCounts: interactionCounts });
};
exports.Interactions = Interactions;
var LoadedInteractions = function (_a) {
    var interactionCounts = _a.interactionCounts;
    var _b = (0, UseChartMappings_1.useChartMappings)(interactionCounts.map(function (_a) {
        var index = _a.index, target = _a.target, count = _a.count, percentage = _a.percentage;
        return ({
            index: index,
            name: target,
            value: count,
            percentage: percentage,
        });
    })), dataForChart = _b.dataForChart, getColourForIndex = _b.getColourForIndex, onChartSegmentHover = _b.onChartSegmentHover, onTableHover = _b.onTableHover, activeChartIndex = _b.activeChartIndex, activeTableIndices = _b.activeTableIndices;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxl", justify: "spaceBetween", align: "start", wrap: true },
        react_1.default.createElement(Table_1.Table, { data: interactionCounts, columns: [
                {
                    heading: "Target",
                    className: styles.interactionNameHeading,
                    renderCellFn: function (rowData) { return renderInteractionNameCell(rowData, getColourForIndex); },
                    sortOptions: [
                        {
                            icon: react_1.default.createElement(icons_1.SortAscending, null),
                            description: "A - Z",
                            compareFn: function (a, b) { return (a.target.toLowerCase() < b.target.toLowerCase() ? -1 : 1); },
                        },
                        {
                            icon: react_1.default.createElement(icons_1.SortDescending, null),
                            description: "Z - A",
                            compareFn: function (a, b) { return (a.target.toLowerCase() < b.target.toLowerCase() ? 1 : -1); },
                        },
                    ],
                },
                {
                    heading: "Type",
                    renderCellFn: function (_a) {
                        var interactionType = _a.interactionType;
                        return "".concat(interactionType);
                    },
                    sortOptions: [
                        {
                            icon: react_1.default.createElement(icons_1.SortAscending, null),
                            description: "A - Z",
                            compareFn: function (a, b) { return (a.interactionType.toLowerCase() < b.interactionType.toLowerCase() ? -1 : 1); },
                        },
                        {
                            icon: react_1.default.createElement(icons_1.SortDescending, null),
                            description: "Z - A",
                            compareFn: function (a, b) { return (a.interactionType.toLowerCase() < b.interactionType.toLowerCase() ? 1 : -1); },
                        },
                    ],
                },
                {
                    heading: "Interactions",
                    renderCellFn: function (_a) {
                        var count = _a.count;
                        return "".concat(count);
                    },
                    sortOptions: interactionCountSortOptions,
                },
                {
                    heading: "Percentage",
                    renderCellFn: function (_a) {
                        var percentage = _a.percentage;
                        return (0, Utils_1.toRoundedPercentage)(percentage);
                    },
                    sortOptions: interactionCountSortOptions,
                },
            ], activeTableIndices: activeTableIndices, onTableHover: onTableHover, defaultSortState: { columnIndex: 1, sortOptionIndex: 0 }, localStorageKey: "page-analytics-interactions-sort" }),
        react_1.default.createElement("div", { className: styles.chartContainer },
            react_1.default.createElement(DonutChart_1.DonutChart, { data: dataForChart, activeIndex: activeChartIndex, onHover: onChartSegmentHover }))));
};
function renderInteractionNameCell(_a, getColourForIndex) {
    var _b;
    var index = _a.index, target = _a.target, interactionType = _a.interactionType;
    var Icon = iconMap[interactionType];
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "s" },
        react_1.default.createElement(Icon, { className: styles.firstColumnIcon, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[kaleidoscope_1.iconVars.color] = getColourForIndex(index), _b)) }),
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, target)));
}
var iconMap = {
    "ROI Calculator": icons_1.WidgetRoi,
    Accordion: icons_1.AccordionLeftButton,
    "Block Unfolded": icons_1.Add,
    "Navigation menu": icons_1.Menu,
    "Button Clicked": icons_1.Button,
};
var interactionCountSortOptions = [
    {
        icon: react_1.default.createElement(icons_1.SortDescending, null),
        description: "Descending",
        compareFn: function (a, b) { return b.count - a.count; },
    },
    {
        icon: react_1.default.createElement(icons_1.SortAscending, null),
        description: "Ascending",
        compareFn: function (a, b) { return a.count - b.count; },
    },
];
